<template>
  <div class="x-tablelist-view" data-automation="manageProduct">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @search="seach"
      @resetsearch="resetsearch"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box" v-if="isShow == true">
      <ux-table
        ref="table"
        :showPage="showPage"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns1"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        :emptyText="$t('HT.nodata')"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
    <div class="x-table-box" v-else>
      <ux-table
        ref="table"
        :showPage="showPage"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns2"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :emptyText="$t('HT.nodata')"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userData: {}, // 登录者信息
      word: this.$t('HT.options.productStatus2'),
      showPage: true,
      layout: [
        // 搜索项配置
        {
          type: 'input',
          key: 'name',
          placeholder: this.$t('HT.rules.addProduct.name'),
          hideBtn: false
        },
        {
          type: 'button',
          text: this.$t('HT.reset'),
          plain: true,
          event: 'resetsearch'
        }
      ],
      isShow: true,
      columns1: [
        // 表头数据
        {
          label: this.$t('HT.unbindApi.name'),
          tooltip: true,
          align: 'left',
          render: (h, params) => {
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'productAllInfo',
                      query: { id: params.id }
                    });
                  }
                }
              },
              params.name
            );
          }
        },
        {
          label: this.$t('HT.apiStepOne.remark'),
          prop: 'remark',
          align: 'left',
          tooltip: true
        },
        {
          label: this.$t('HT.orderManage.status'),
          prop: 'published',
          tooltip: true,
          align: 'left',
          formatter: (row, column, cellValue) => {
            return this.$opt.switchStr(cellValue, this.$opt.productStatus);
          }
        },
        {
          label: this.$t('HT.productAll.createdBy'),
          prop: 'created_by',
          align: 'left',
          tooltip: true
        },
        {
          label: this.$t('HT.createdTime'),
          prop: 'created_date',
          align: 'left',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          align: 'left',
          hidden: !this.$hasModule(20),
          width: 250,
          render: (h, params) => {
            return h(
              'div',
              {
                attrs: {
                  style: 'overflow:'
                }
              },
              [
                h(
                  'ux-button',
                  {
                    props: {
                      type: 'primary',
                      text: true
                    },
                    attrs: {
                      style: 'margin-right: 10px'
                    },
                    on: {
                      click: () => {
                        this.$router.push({ name: 'productAllInfo', query: { id: params.id } });
                      }
                    }
                  },
                  this.$t('HT.manage')
                ),
                h(
                  'ux-button',
                  {
                    props: {
                      type: 'primary',
                      text: true
                    },
                    attrs: {
                      style: 'margin-right: 10px'
                    },
                    on: {
                      click: () => {
                        this.delete(params);
                      }
                    }
                  },
                  this.$t('HT.delete')
                ),
                h('moreDropdown', {
                  props: {
                    list: [
                      {
                        label: this.$t('HT.soldIn'),
                        disabled: params.published == 1 || params.published == 2,
                        event: 'startUp'
                      },
                      {
                        label: this.$t('HT.soldOut'),
                        disabled: params.published == 0,
                        event: 'endDown'
                      }
                    ],
                    text: this.$t('HT.more')
                  },
                  on: {
                    clickItem: (method) => {
                      this[method](params);
                    }
                  }
                })
              ]
            );
          }
        }
      ],
      columns2: [
        // 表头数据
        {
          label: this.$t('HT.unbindApi.name'),
          tooltip: true,
          align: 'left',
          render: (h, params) => {
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    this.$router.push({
                      name: 'productAllInfo',
                      query: { id: params.id }
                    });
                  }
                }
              },
              params.name
            );
          }
        },
        {
          label: this.$t('HT.apiStepOne.remark'),
          prop: 'remark',
          align: 'left',
          tooltip: true
        },
        // {
        //     label: '创建人',
        //     prop: 'created_by',
        //     tooltip: true
        // },
        {
          label: this.$t('HT.createdTime'),
          prop: 'created_date',
          align: 'left',
          tooltip: true
        }
      ],
      filter: {
        // 查询参数
        name: '', // 应用名称
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    this.getAllList(this.filter);
    this.getSupervisor();
    this.userData = this.$store.state.login.userData;
  },

  methods: {
    /**
     * 获取超级管理员字段
     * @param {String}
     */
    getSupervisor() {
      this.isShow = JSON.parse(localStorage.getItem('userData')).supervisor;
    },

    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getAllList(params) {
      this.$uxLoading.show();
      this.$api.product.getAllList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },
    /**
     * 重置搜索项
     */
    resetsearch() {
      console.log('重置');
      this.filter.name = '';
      this.seach();
    },
    /**
     * 上架
     * @param {Object} params 表单参数
     */
    startUp(params) {
      const title = this.$t('HT.productAll.up.title');
      this.$uxModal.show({
        title,
        type: 'warning',
        confirm: () => {
          this.$api.product.supAuditProducts(params.id, { published: 2 }).then((res) => {
            if (res.code == 10000) {
              this.$uxModal.hide();
              this.$uxMessage.success(this.$t('HT.productAll.success'));
              this.getAllList(this.filter);
            }
          });
        }
      });
    },

    /**
     * 下架
     * @param {Object} params 表单参数
     */
    endDown(params) {
      const title = this.$t('HT.productAll.down.title');
      this.$uxModal.show({
        title,
        type: 'warning',
        confirm: () => {
          this.$uxLoading.show();
          this.$api.product.release(params.id, { published: 0 }).then((res) => {
            if (res.code == 10000) {
              this.$uxModal.hide();
              this.$uxMessage.success(this.$t('HT.apiList.soldOutApi.success'));
              this.getAllList(this.filter);
            }
          });
        }
      });
    },

    /**
     * 删除
     * @param {Object} params 表单参数
     */
    delete(params) {
      if (params.published == false) {
        const title = this.$t('HT.productAll.del');
        const content = this.$t('HT.productAll.del.content');
        this.$uxModal.show({
          title,
          content,
          confirm: () => {
            this.delList(params);
          }
        });
      } else {
        this.$uxModal.hide();
        this.$uxMessage.warning(this.$t('HT.productAll.del.warning'));
      }
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(params) {
      this.$uxLoading.show();
      if (params.published == false) {
        this.$api.product.delList(params.id).then((res) => {
          if (res.code == 10000) {
            this.$uxModal.hide();
            this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
            if (this.tableData.list.length === 1) {
              this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
            }
            this.getAllList(this.filter);
          }
        });
      } else {
        this.$uxModal.hide();
        this.$uxMessage.error(this.$t('HT.addApi.delError'));
        this.getAllList(this.filter);
      }
    },

    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getAllList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getAllList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getAllList(this.filter);
    }
  }
};
</script>
